import App from "@/app/App.vue";
import axiosPlugin from "@/plugins/axios";
import vuetify from "@/plugins/vuetify";
import router from "@/plugins/router";
import store from "@/store";
import 'mapbox-gl/dist/mapbox-gl.css';

import { createApp } from "vue";

// Vue.config.productionTip = false;

const app = createApp(App)

app.config.globalProperties.$map = {};
app.use(router)
app.use(store)
app.use(vuetify)
app.use(axiosPlugin)
app.mount("#app")
